module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['forum-header', {
      'is-static': _vm.isStatic || _vm.isFixed
    }]
  }, [_c('img', {
    staticClass: "bk-logo",
    attrs: {
      "src": require("../images/common/logo.png"),
      "width": "188px",
      "height": "32px",
      "alt": "蓝鲸logo"
    },
    on: {
      "click": function($event) {
        return _vm.goToDoc({
          url: '',
          target: true
        })
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "logo-title"
  }, [_vm._v("学习社区")]), _vm._v(" "), _c('ul', {
    staticClass: "nav-list"
  }, _vm._l((_vm.navList), function(navItem, navIdx) {
    return _c('li', {
      key: navIdx,
      class: ['nav-item', {
        'is-active': _vm.curNavTab === navItem.name
      }],
      on: {
        "click": function($event) {
          return _vm.goToDoc(navItem)
        }
      }
    }, [_vm._v("\n            " + _vm._s(navItem.title) + "\n        ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "ask-btn primary",
    on: {
      "click": function($event) {
        return _vm.onCreateAsk()
      }
    }
  }, [_vm._v("提问")]), _vm._v(" "), _c('div', {
    staticClass: "ask-btn default",
    on: {
      "click": function($event) {
        return _vm.onCreateAsk(true)
      }
    }
  }, [_vm._v("写文章")]), _vm._v(" "), (!_vm.isLogin) ? _c('span', {
    staticClass: "login-btn",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("登录")]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('span', {
    staticClass: "login-btn register",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("注册")]) : [_c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "click",
      "popper-class": "msg-popover"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('span', {
    staticClass: "msg-icon",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    class: ['message-solid', {
      'active': _vm.visible
    }]
  }), _vm._v(" "), (_vm.isHaveUnread) ? _c('i', {
    staticClass: "red-circle"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "popover-content"
  }, [_c('p', {
    staticClass: "msg-title"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v("\n                        消息通知\n                        "), _c('span', {
    staticClass: "num"
  }, [_vm._v("(" + _vm._s(_vm.msgLength) + ")")])]), _vm._v(" "), _c('span', {
    staticClass: "view-more",
    on: {
      "click": _vm.onViewMore
    }
  }, [_vm._v("查看更多")])]), _vm._v(" "), _c('el-tabs', {
    staticClass: "msg-content",
    on: {
      "tab-click": _vm.handleTabClick
    },
    model: {
      value: (_vm.activeMsg),
      callback: function($$v) {
        _vm.activeMsg = $$v
      },
      expression: "activeMsg"
    }
  }, _vm._l((_vm.msgTabList), function(tabItem) {
    return _c('el-tab-pane', {
      key: tabItem.name,
      staticClass: "tab-item",
      attrs: {
        "name": tabItem.name
      }
    }, [_c('span', {
      attrs: {
        "slot": "label"
      },
      slot: "label"
    }, [_c('el-badge', {
      attrs: {
        "hidden": !_vm.tabsTotal[tabItem.name],
        "value": _vm.tabsTotal[tabItem.name],
        "max": 99
      }
    }, [_vm._v("\n                        " + _vm._s(tabItem.label) + "\n                    ")])], 1)])
  }), 1), _vm._v(" "), _c('ul', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading ? false : _vm.tabLoading),
      expression: "loading ? false : tabLoading"
    }],
    staticClass: "val-list",
    attrs: {
      "element-loading-text": "拼命加载中"
    }
  }, [(_vm.componentData.length) ? _vm._l((_vm.componentData), function(infoItem, infoIndex) {
    return _c('li', {
      key: infoIndex,
      staticClass: "val-item"
    }, [_c('span', {
      staticClass: "val-circle"
    }), _vm._v(" "), _c('p', {
      staticClass: "val-content",
      domProps: {
        "innerHTML": _vm._s(_vm.filterXSS(infoItem.notify))
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "val-time"
    }, [_vm._v(_vm._s(infoItem.updated))])])
  }) : _c('li', {
    staticClass: "data-null"
  }, [_c('img', {
    attrs: {
      "src": require("../images/personal_center/data-null.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("没有数据")])])], 2)], 1)]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "bottom",
      "trigger": "hover",
      "width": "227",
      "popper-class": 'user-info-pop'
    }
  }, [_c('div', {
    staticClass: "user-info",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userInfo.nick_name || _vm.userInfo.username))]), _vm._v(" "), (_vm.userInfo.is_official) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "蓝鲸智云官方",
      "placement": "right"
    }
  }, [_c('svg', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-lanjingguanfang"
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.userInfo.is_vip) ? _c('el-tooltip', {
    attrs: {
      "effect": "light",
      "content": "核心用户",
      "placement": "right"
    }
  }, [_c('span', {
    staticClass: "icon-vipuser"
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "triangle"
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "whale",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/personal_center/')
      }
    }
  }, [(!_vm.userInfo.avatar || _vm.userInfo.avatar.substr(0, 1) === '?') ? _c('img', {
    attrs: {
      "src": require("../images/community/coins.png")
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.userInfo.avatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("鲸币")]), _vm._v(" "), _c('span', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm._f("formatNumber")(_vm.userInfo.bkb)))])]), _vm._v(" "), _c('p', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/personal_center/')
      }
    }
  }, [_vm._v("个人中心")]), _vm._v(" "), _c('p', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/personal_center/store')
      }
    }
  }, [_vm._v("鲸币商城")]), _vm._v(" "), _c('p', {
    staticClass: "menu-item",
    on: {
      "click": function($event) {
        return _vm.skip('/s-mart/vip')
      }
    }
  }, [_vm._v(_vm._s(_vm.userInfo.is_vip ? '查看我的核心权益' : '申请成为核心用户'))]), _vm._v(" "), _c('a', {
    staticClass: "menu-item",
    attrs: {
      "href": "javascript:smart.logout(logout_callback);"
    }
  }, [_vm._v("退出登录")])])], _vm._v(" "), _c('secondary', {
    attrs: {
      "show": _vm.secondaryState,
      "hasEmail": _vm.emailState,
      "hasPhone": _vm.phoneState
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-293b05c2!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/forumHeader.vue
// module id = vQXG
// module chunks = 15